module.exports = __webpack_public_path__ + "fonts/Rubik-300-cyrillic9.344f0e6.woff2";